/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SearchClassifyResponseClassifiersItem3 = typeof SearchClassifyResponseClassifiersItem3[keyof typeof SearchClassifyResponseClassifiersItem3];


export const SearchClassifyResponseClassifiersItem3 = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;
